export default __webpack_public_path__ + "static/media/2.73842b80.jpg";